import { NextPage } from 'next'
import React from 'react'
import { MainLayout } from '../../modules/app/main-layout'
import { KitSlug } from '../../modules/slug/kit'

const KitPage: NextPage = () => {
  return (
    <MainLayout hasMarginBottom={false} enabledBackToTop>
      <KitSlug />
    </MainLayout>
  )
}

export default KitPage
